import { useState } from "react";
import { useScreen } from "../../context/ScreenContext";

export default function TabSelector({
  tabs,
  selected,
  setSelected,
  setSelectedIndex,
}) {
  const { isMobile } = useScreen();
  const getSliderPosition = (tab) => {
    switch (tab) {
      case "CAI":
        return "left-[4px]";
      case "Dev41":
        return "left-1/2 -translate-x-1/2";
      case "Recruit41":
        return isMobile ? "right-[4px]" : "left-[calc(100%-140px)]";
      case "Business":
        return "left-[4px]";
      case "Technology":
        return "left-1/2 -translate-x-1/2";
      case "Talent":
        return "right-[4px]";
      default:
        return "";
    }
  };

  return (
    <div className="relative w-full lg:w-[500px] h-[42px] bg-[#F3F3F3] rounded-[11px] flex items-center justify-between px-[4px]">
      {/* Slider */}
      <div
        className={`absolute top-[4px] h-[34px] md:w-[135px] w-[110px] rounded-[10px] bg-white transition-all duration-500 ease-in-out
        shadow-[0px_1px_1px_-1px_rgba(0,0,0,0.22),0px_2px_2px_-2px_rgba(0,0,0,0.19),0px_10px_10px_-4px_rgba(0,0,0,0.08)]
        ${getSliderPosition(selected)}`}
      />

      {/* Tabs */}
      {tabs.map((tab, ind) => (
        <button
          key={tab}
          onClick={() => {
            setSelected(tab);
            setSelectedIndex(ind);
          }}
          className={`z-10 w-[110px] md:w-[140px] h-[34px] md:text-base text-sm flex items-center justify-center rounded-[10px] cursor-pointer
            transition-colors duration-300 font-montserrat ${
              selected === tab ? "text-black font-medium" : "text-gray-400"
            }`}
        >
          {tab}
        </button>
      ))}
    </div>
  );
}
